import { SellingCompanyReport } from 'tms-lib';
import { PurchaseOrderReceiptsReport } from './purchase-order-receipts-report';

export interface PurchaseReceiptsReport {
  supplierDeliveryNoteNo: string;
  dateDelivered: Date;
  supplierKey: string;
  supplierName: string;
  currency: string;
  currencySymbol: string;
  supplierAddress: string;
  deliveryAddress: string;
  enteredBy: string;
  totalQuantity: number;
  nettValue: number;
  taxValue: number;
  overallValue: number;
  deliveryTermCharge: number;
  importDuty: number;

  sellingCompany: SellingCompanyReport;
  purchaseOrderReceipts: PurchaseOrderReceiptsReport[];
}
